import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

// importing custom component
import { getVcFeed } from './actions';
import { generateAuthHeaderFromStore } from '../../utils/authUtils';
import VisualConversation from '../VisualConversation';
import LoadingData from '../../components/LoadingData';

// styles
import styles from './styles';
import {
  REQUEST_AUTH_FEED_COMMENT_HOME_PAGE,
  REQUEST_AUTH_FEED_LIKE_HOME_PAGE,
  REQUEST_AUTH_VC_PROFILE_FOLLOW_HOME_PAGE,
} from '../AuthModal/actions';

class VisualConversationFeed extends Component {
  componentDidMount() {
    this.loadMore();
  }

  loadMore() {
    const {
      loadVcFeed, authHeaders, nextPage, isRequesting,
    } = this.props;
    if (!isRequesting && nextPage) {
      loadVcFeed(authHeaders, { page: nextPage });
    }
  }

  render() {
    const {
      classes, list, nextPage,
    } = this.props;
    return (
      <div className={classes.vc_wrapper}>
        <div>
          <List className="overFlowHidden">
            <InfiniteScroll
              pageStart={0}
              loadMore={() => { this.loadMore(); }}
              hasMore={!!nextPage}
              initialLoad={false}
              threshold={20}
              loader={<LoadingData key={0} />}
            >
              {list.map(id => (
                <ListItem key={id} className={classes.singleItem}>
                  <VisibilitySensor
                    partialVisibility
                    offset={{ top: -800, bottom: -800 }}
                  >
                    {({ isVisible }) => (
                      <VisualConversation
                        id={id}
                        isVisible={isVisible}
                        authLikeAction={REQUEST_AUTH_FEED_LIKE_HOME_PAGE}
                        authCommentAction={REQUEST_AUTH_FEED_COMMENT_HOME_PAGE}
                        authFollowAction={REQUEST_AUTH_VC_PROFILE_FOLLOW_HOME_PAGE}
                      />
                    )}
                  </VisibilitySensor>
                </ListItem>
              ))}
            </InfiniteScroll>
          </List>
        </div>
      </div>
    );
  }
}
const VisualConversationFeedWithStyles = withStyles(styles)(VisualConversationFeed);

VisualConversationFeed.propTypes = {
  list: PropTypes.object.isRequired,
  nextPage: PropTypes.string.isRequired,
  authHeaders: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  list: state.vcFeed.get('list'),
  nextPage: state.vcFeed.get('nextPage'),
  authHeaders: generateAuthHeaderFromStore(state),
});

const mapDispatchToProps = dispatch => ({
  loadVcFeed: (headers, params) => {
    dispatch(getVcFeed(headers, params));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VisualConversationFeedWithStyles);



// WEBPACK FOOTER //
// ./src/containers/VisualConversationFeed/index.js